module.exports = {
  domain: String(process.env.REACT_APP_AUTH0_DOMAIN),
  clientID: String(process.env.REACT_APP_AUTH0_CLIENT_ID),
  redirectUri: `${window.location.origin}/callback`,
  responseType: "token id_token",
  scope: "openid profile email",
  audience: "https://ampersand-api.demo.com",
};
